import { TimeUnits } from './timer.enums';
import { TimeVisibility } from './time.visibility.enum';

export class TimeUtils {

    constructor() {}

    static getTimeFromSeconds(seconds: number): Date {
        const date = new Date();
        let _seconds = seconds;

        const minuteUnit = TimeUnits.MINUTE;
        const hourUnit = TimeUnits.HOUR;

        const hours = (seconds / hourUnit);
        const minutes = (seconds / minuteUnit);

        // tslint:disable: no-bitwise
        _seconds -= (TimeUnits.HOUR * ~~hours);
        _seconds -= (TimeUnits.MINUTE * ~~minutes);

        date.setHours(hours);
        date.setMinutes(minutes);
        date.setSeconds(_seconds);

        return date;
    }

    static getFixedTime(date: Date, visibility: TimeVisibility): string {

        let result = '';

        const hours = date.getHours();
        const minutes = date.getMinutes();
        const seconds = date.getSeconds();

        const _hours = (hours < 10) ? `0${hours}` : `${hours}`;
        const _minutes = (minutes < 10) ? `0${minutes}` : `${minutes}`;
        const _seconds = (seconds < 10) ? `0${seconds}` : `${seconds}`;

        // Check if time preference is fixed
        if (visibility === TimeVisibility.FIXED) {
            if (hours > 0) { result += (`${_hours}:`); }

            (minutes > 0)
                ? result += (`${_minutes}:`)
                : result += '00:';

            (seconds > 0)
                ? result += (`${_seconds}`)
                : result += '00';

        } else {
            result = `${_hours}:${_minutes}:${_seconds}`;
        }

        return result;
    }

    convertDateTime(currentMeasure: TimeUnits, newMeasure: TimeUnits): Date {
        return new Date();
    }
}
